<template>
  <div class="usuario-filtro-salvo">
    <v-row class="align-center">
      <v-col cols="12" md="5">
        <v-autocomplete
          v-model="filtroSelecionado"
          :items="filtrosSalvos"
          item-text="descricao"
          return-object
          clearable
          dense
          flat
          filled
          solo
          hide-details
          prepend-inner-icon="mdi-filter-variant"
          :disabled="disabled || loading"
          :loading="loading"
          :label="$t('Filtros_salvos')"
          :no-data-text="$t('Nenhum_filtro_salvo')"
          class="
            input-style
            font-size-input
            text-light-input
            placeholder-light
            input-icon
          "
          @change="onFiltroSelecionadoChange"
        />
      </v-col>

      <v-col cols="12" md="7" class="d-flex align-center flex-wrap">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              class="btn-ls me-2 my-1"
              :disabled="disabled || loading || !filtroSelecionado"
              v-bind="attrs"
              v-on="on"
              @click="aplicarFiltroSelecionado"
            >
              <v-icon color="#67748e">mdi-filter-check-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Aplicar") }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              class="btn-ls me-2 my-1"
              :disabled="disabled || loading || !filtroSelecionado"
              v-bind="attrs"
              v-on="on"
              @click="modalExcluir = true"
            >
              <v-icon color="#67748e">mdi-delete-outline</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Excluir_filtro") }}</span>
        </v-tooltip>

        <v-btn
          :loading="loading"
          :disabled="disabled || saveDisabled"
          class="
            ma-1
            font-weight-bold
            text-none
            btn-primary
            bg-gradient-primary
            py-3
            px-6
            ms-3
          "
          height="39"
          @click="abrirModalSalvar"
        >
          <v-icon left dark>mdi-content-save-outline</v-icon>
          {{ $t("Salvar_filtro") }}
        </v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="modalSalvar" max-width="520" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("Salvar_filtro") }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            ref="descricaoInput"
            v-model="descricao"
            :label="$t('Descricao_do_filtro')"
            hide-details
            dense
            flat
            filled
            solo
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            @keyup.enter="salvarFiltro"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            :disabled="loading"
            @click="modalSalvar = false"
          >
            {{ $t("Cancelar") }}
          </v-btn>
          <v-btn
            height="39"
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            :loading="loading"
            @click="salvarFiltro"
          >
            {{ $t("Salvar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalExcluir" max-width="350" persistent>
      <v-card>
        <v-card-title class="headline">
          {{ $t("Tem_certeza?") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            height="39"
            class="
              font-weight-bold
              text-capitalize
              btn-ls btn-secondary
              bg-gradient-light
              py-3
              px-6
            "
            :disabled="loading"
            @click="modalExcluir = false"
          >
            {{ $t("Cancelar") }}
          </v-btn>
          <v-btn
            height="39"
            class="
              ma-1
              font-weight-bold
              text-none
              btn-primary
              bg-gradient-primary
              py-3
              px-6
              ms-3
            "
            :loading="loading"
            @click="excluirFiltro"
          >
            {{ $t("Confirmar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UsuarioFiltroDataService from "@/services/acessos/UsuarioFiltroDataService";

export default {
  name: "UsuarioFiltroSalvo",
  props: {
    tela: {
      type: String,
      required: true,
    },
    filtroAtual: {
      type: Object,
      required: true,
    },
    descricaoPadrao: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    saveDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      filtrosSalvos: [],
      filtroSelecionado: null,
      modalSalvar: false,
      modalExcluir: false,
      descricao: "",
      loading: false,
    };
  },
  mounted() {
    this.carregarFiltros();
  },
  watch: {
    tela() {
      this.carregarFiltros();
    },
  },
  methods: {
    carregarFiltros() {
      if (!this.tela) return;
      this.loading = true;
      UsuarioFiltroDataService.findByTela(this.tela)
        .then((response) => {
          this.filtrosSalvos = response.data || [];
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        });
    },

    abrirModalSalvar() {
      this.descricao = this.descricaoPadrao || "";
      this.modalSalvar = true;
      this.$nextTick(() => {
        if (
          this.$refs.descricaoInput &&
          typeof this.$refs.descricaoInput.focus === "function"
        ) {
          this.$refs.descricaoInput.focus();
        }
      });
    },

    salvarFiltro() {
      const descricao = String(this.descricao || "").trim();
      if (!descricao) {
        this.$swal.fire(this.$t("Erro"), this.$t("Campo_obrigatorio"), "error");
        return;
      }

      this.loading = true;
      UsuarioFiltroDataService.create({
        tela: this.tela,
        descricao,
        filtros: JSON.stringify(this.filtroAtual || {}),
      })
        .then((response) => {
          this.modalSalvar = false;
          this.filtroSelecionado = response.data;
          this.$emit("saved", response.data);
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("Filtro_salvo_com_sucesso"),
            "success"
          );
          this.carregarFiltros();
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
        });
    },

    onFiltroSelecionadoChange(filtroSelecionado) {
      if (!filtroSelecionado) return;
      this.emitirFiltroSelecionado(filtroSelecionado, false);
    },

    aplicarFiltroSelecionado() {
      this.emitirFiltroSelecionado(this.filtroSelecionado, true);
    },

    emitirFiltroSelecionado(filtroSelecionado, mostrarErroSelecao) {
      if (!filtroSelecionado) {
        if (!mostrarErroSelecao) return;
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Selecione_um_filtro"),
          "error"
        );
        return;
      }

      try {
        const filtros =
          typeof filtroSelecionado.filtros === "string"
            ? JSON.parse(filtroSelecionado.filtros)
            : filtroSelecionado.filtros || {};
        this.$emit("apply", filtros);
      } catch (error) {
        this.$emit("error", error);
        this.$swal.fire(
          this.$t("Erro"),
          this.$t("Nao_foi_possivel_aplicar_filtro"),
          "error"
        );
      }
    },

    excluirFiltro() {
      if (!this.filtroSelecionado || !this.filtroSelecionado.id) return;
      this.loading = true;
      UsuarioFiltroDataService.delete(this.filtroSelecionado.id)
        .then(() => {
          this.modalExcluir = false;
          this.filtroSelecionado = null;
          this.$swal.fire(
            this.$t("Sucesso"),
            this.$t("deletado_sucesso"),
            "success"
          );
          this.carregarFiltros();
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
          this.$swal.fire(
            this.$t("Erro"),
            this.$t("Tente_novamente_mais_tarde"),
            "error"
          );
        });
    },
  },
};
</script>
